import { cn } from "../../lib/utils"

type SwitchProps = {
  className?: string
  id: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  label: string
  /** Keep the compact track inside a fully clickable 44px target. */
  generousTarget?: boolean
}

export function Switch({
  className,
  id,
  checked,
  onCheckedChange,
  disabled = false,
  label,
  generousTarget = false,
}: SwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        "relative inline-flex w-11 shrink-0 items-center justify-center rounded-full outline-none transition-colors duration-200 motion-reduce:transition-none",
        generousTarget ? "h-11" : "h-6",
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
    >
      <span
        className={cn(
          "relative block h-6 w-11 rounded-full border",
          checked ? "border-primary bg-primary" : "border-border bg-muted"
        )}
      >
        <span
          aria-hidden="true"
          className={cn(
            "pointer-events-none absolute left-0 top-0.5 size-5 rounded-full bg-card shadow-card",
            "transition-transform duration-200 ease-[var(--ease-product-out)] motion-reduce:transition-none",
            checked ? "translate-x-5" : "translate-x-0.5"
          )}
        />
      </span>
    </button>
  )
}
